import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { TextField, IconButton, Tooltip } from "@material-ui/core";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import DeleteIcon from "@material-ui/icons/Delete";
import { getFileUrl } from "../../../../common/tools";

export const reorder = (list, startIndex, endIndex) => {
  const result = [...list];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

/**
 * Danh sách ảnh của dự án. Thứ tự trên giao diện = sortOrder khi lưu.
 * items: [{ key, id, fileId, file, title, description }]
 * file: { fileId, fileName, filePreview } | null (null = file đã bị xoá khỏi Quản lý tài liệu)
 * errors: { [index]: message }
 */
const GalleryEditor = ({ items, errors = {}, onChange }) => {
  const updateItem = (index, field, value) => {
    onChange(items.map((item, i) => (i === index ? { ...item, [field]: value } : item)));
  };

  const removeItem = (index) => {
    onChange(items.filter((_, i) => i !== index));
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    onChange(reorder(items, result.source.index, result.destination.index));
  };

  if (items.length === 0) {
    return <p className="text-muted mb-0">Chưa có ảnh nào.</p>;
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="investment-gallery">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {items.map((item, index) => {
              const file = item.file;
              return (
                <Draggable key={item.key} draggableId={item.key} index={index}>
                  {(dragProvided, snapshot) => (
                    <div
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      className="d-flex align-items-center border rounded p-2 mb-2 bg-white"
                      style={{
                        ...dragProvided.draggableProps.style,
                        boxShadow: snapshot.isDragging ? "0 4px 12px rgba(0,0,0,.15)" : "none",
                      }}
                    >
                      <span {...dragProvided.dragHandleProps} className="mr-2 text-muted" title="Kéo để sắp xếp">
                        <DragIndicatorIcon />
                      </span>
                      <div
                        className="mr-3 d-flex align-items-center justify-content-center bg-light"
                        style={{ width: 96, height: 64, flexShrink: 0 }}
                      >
                        {file && file.filePreview ? (
                          <img
                            src={getFileUrl(file.filePreview)}
                            alt={file.fileName}
                            style={{ maxWidth: "100%", maxHeight: "100%" }}
                          />
                        ) : (
                          <small className="text-danger text-center">File không tồn tại</small>
                        )}
                      </div>
                      <div className="flex-grow-1 row">
                        <div className="col-md-5">
                          <TextField
                            fullWidth
                            size="small"
                            label="Tiêu đề"
                            value={item.title}
                            onChange={(e) => updateItem(index, "title", e.target.value)}
                            inputProps={{ maxLength: 255 }}
                          />
                        </div>
                        <div className="col-md-7">
                          <TextField
                            fullWidth
                            size="small"
                            label="Mô tả"
                            value={item.description}
                            onChange={(e) => updateItem(index, "description", e.target.value)}
                          />
                        </div>
                        {file && file.fileName && (
                          <small className="col-12 text-muted mt-1">{file.fileName}</small>
                        )}
                        {errors[index] && (
                          <span className="col-12 error mt-1">{errors[index]}</span>
                        )}
                      </div>
                      <Tooltip title="Bỏ ảnh">
                        <IconButton aria-label="delete" onClick={() => removeItem(index)}>
                          <DeleteIcon className="text-danger" />
                        </IconButton>
                      </Tooltip>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default GalleryEditor;
